export enum UiEvent {
  PAGE_LOAD = 'ui.pageload',
}

export enum PageEventView {
  LOGIN,
  REGISTER,
  SUBSCRIPTION,
  FIRST_SUBSCRIPTION,
  FIRST_SCHEDULE,
  SCHEDULE,
  CHECKOUT_PREVIEW,
  ACCOUNT,
  FIRST_SHIP_AND_PAY,
  SHIP_AND_PAY,
  SURVEY,
  REFERRAL,
  LANDING,
  NOT_FOUND,
  FIRST_SHIP,
  SHIP,
  FIRST_PAY,
  PAY,
  TRACKING,
  PLACED_ORDER,
  OPEN_MENU,
  PROFILE_MENU,
  // OTHERS
  LOOK_AND_LIKE,
  INSPIRATION,
  INBOX,
  DELETE_ACCOUNT,
  DELETE_ACCOUNT_CONFIRM,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_ERROR,
  CANCEL_BOX,
  CANCEL_BOX_CONFIRM,
  CANCEL_BOX_SUCCESS,
  CANCEL_BOX_ERROR,
  SUPPORT,
  FAQS,
}

export interface PageViewEventPayload {
  view: PageEventView;
  category?: string;
  userEmail?: string;
  userFirstName?: string;
  userLastName?: string;
  userPhone?: string;
  userCity?: string;
  userZip?: string;
  userUuid?: string;
  userId?: string;
  calendarDays?: number;
}
